import type {IssueEventItem, IssueEventType} from '../../../../page-data/payloads/timeline'

const actionText: Partial<Record<IssueEventType, string>> = {
  review_requested: 'requested a review',
  review_request_removed: 'removed a review request',
}

export function IssueEventText({item}: {item: IssueEventItem}) {
  const {eventType, assigneeLogin} = item.additionalInfo

  if ((eventType === 'assigned' || eventType === 'unassigned') && assigneeLogin) {
    return (
      <>
        {eventType} <strong>{assigneeLogin} </strong>
      </>
    )
  }

  return <>{actionText[eventType] ?? eventType}</>
}
